export const playIcon = (
    <svg viewBox="0 0 20 27" fill="none">
      <path
        d="M3.80208 2.03128C3.03125 1.55732 2.0625 1.5417 1.27604 1.98441C0.489583 2.42712 0 3.26045 0 4.1667V22.5C0 23.4063 0.489583 24.2396 1.27604 24.6823C2.0625 25.125 3.03125 25.1042 3.80208 24.6355L18.8021 15.4688C19.5469 15.0157 20 14.2084 20 13.3334C20 12.4584 19.5469 11.6563 18.8021 11.198L3.80208 2.03128Z"
        fill="#2A3663"
      />
    </svg>
  );
  export const shivonIcon = (
    <svg viewBox="0 0 16 12" fill="none">
      <path
        d="M7.07208 0.359661C7.05083 0.423411 6.98708 0.465494 6.91292 0.455078C6.84917 0.433828 6.80708 0.370494 6.8175 0.296327C6.83875 0.232994 6.9025 0.190494 6.97667 0.200911C7.04042 0.222161 7.0825 0.285911 7.07208 0.359661Z"
        fill="#B59F78"
      />
      <mask
        id="mask0_3_210"
        maskUnits="userSpaceOnUse"
        x="5"
        y="0"
        width="1"
        height="1"
      >
        <path d="M5.49316 0H5.91983V0.387917H5.49316V0Z" fill="currentColor" />
      </mask>
      <g mask="url(#mask0_3_210)">
        <path
          d="M5.8737 0.20087C5.85245 0.28587 5.76745 0.327953 5.69328 0.306703C5.6087 0.28587 5.5662 0.20087 5.58745 0.12712C5.6087 0.0425365 5.69328 3.64427e-05 5.76745 0.0212865C5.85245 0.0425365 5.89495 0.12712 5.8737 0.20087Z"
          fill="#B59F78"
        />
      </g>
      <path
        d="M4.71794 0.317574C4.69669 0.412574 4.60127 0.465491 4.51627 0.444241C4.42085 0.423407 4.36794 0.327991 4.38919 0.243407C4.41044 0.148407 4.50585 0.0954904 4.59044 0.116324C4.68585 0.137574 4.73919 0.232991 4.71794 0.317574Z"
        fill="#B59F78"
      />
      <path
        d="M3.63638 0.687448C3.61513 0.793282 3.50888 0.846199 3.40304 0.824949C3.29679 0.804115 3.24388 0.698282 3.26513 0.592448C3.28638 0.486615 3.39221 0.433698 3.49846 0.454948C3.59388 0.486615 3.65721 0.592448 3.63638 0.687448Z"
        fill="#B59F78"
      />
      <path
        d="M2.66031 1.29044C2.62864 1.4071 2.52239 1.47044 2.40572 1.43877C2.28906 1.4071 2.22572 1.30127 2.25739 1.18502C2.28906 1.06835 2.39531 1.00502 2.51197 1.03669C2.61781 1.05794 2.68156 1.17419 2.66031 1.29044Z"
        fill="#B59F78"
      />
      <path
        d="M1.83347 2.09458C1.80138 2.22166 1.6743 2.29541 1.55763 2.26374C1.43055 2.23208 1.35597 2.10499 1.38805 1.98874C1.41972 1.86166 1.54722 1.78791 1.66388 1.81958C1.78055 1.85124 1.86513 1.96749 1.83347 2.09458Z"
        fill="#B59F78"
      />
      <path
        d="M1.19708 3.07835C1.16499 3.21585 1.02708 3.29002 0.889575 3.25835C0.751658 3.22669 0.677491 3.08919 0.709158 2.95127C0.740825 2.81377 0.878742 2.74002 1.01666 2.77169C1.14374 2.80335 1.22874 2.94085 1.19708 3.07835Z"
        fill="#B59F78"
      />
      <path
        d="M0.783341 4.22088C0.751675 4.36921 0.602924 4.4538 0.454591 4.42171C0.306258 4.39005 0.221258 4.24213 0.252924 4.0938C0.285008 3.94588 0.433341 3.8613 0.581674 3.89296C0.730425 3.92463 0.815008 4.07296 0.783341 4.22088Z"
        fill="#B59F78"
      />
      <mask
        id="mask1_3_210"
        maskUnits="userSpaceOnUse"
        x="0"
        y="4"
        width="1"
        height="2"
      >
        <path d="M0 4.97461H0.693334V5.72128H0V4.97461Z" fill="currentColor" />
      </mask>
      <g mask="url(#mask1_3_210)">
        <path
          d="M0.634863 5.43748C0.592363 5.59623 0.433196 5.69123 0.274029 5.64914C0.115279 5.60664 0.0198624 5.44789 0.0619457 5.28914C0.104446 5.13039 0.263612 5.03539 0.422779 5.07789C0.581529 5.11998 0.677363 5.27873 0.634863 5.43748Z"
          fill="#B59F78"
        />
      </g>
      <path
        d="M0.772856 6.61161C0.730356 6.78077 0.560772 6.87619 0.390772 6.83369C0.221189 6.79119 0.125772 6.62202 0.168272 6.45286C0.210772 6.28369 0.380356 6.18827 0.549939 6.23077C0.709106 6.28369 0.814939 6.45286 0.772856 6.61161Z"
        fill="#B59F78"
      />
      <path
        d="M1.15458 7.7226C1.11208 7.90219 0.931661 8.00802 0.751661 7.96594C0.571244 7.92344 0.465411 7.74344 0.507494 7.56385C0.549994 7.38385 0.730411 7.27802 0.910411 7.32052C1.09083 7.3626 1.20749 7.5426 1.15458 7.7226Z"
        fill="#B59F78"
      />
      <path
        d="M1.76974 8.72744C1.71682 8.91786 1.52599 9.03411 1.33515 8.98119C1.1439 8.92827 1.02724 8.73786 1.08057 8.54744C1.13349 8.35702 1.32432 8.24077 1.51515 8.29369C1.70599 8.33577 1.82265 8.53702 1.76974 8.72744Z"
        fill="#B59F78"
      />
      <path
        d="M2.59681 9.57368C2.54389 9.77452 2.34223 9.89077 2.14098 9.84868C1.93931 9.79577 1.82264 9.59452 1.86514 9.39368C1.91806 9.19285 2.11973 9.07618 2.32139 9.11868C2.52264 9.1716 2.63931 9.37243 2.59681 9.57368Z"
        fill="#B59F78"
      />
      <path
        d="M3.59385 10.2296C3.54094 10.4408 3.32844 10.5679 3.11635 10.515C2.90427 10.4621 2.77719 10.2504 2.8301 10.0392C2.88344 9.82749 3.09552 9.70041 3.3076 9.75332C3.51969 9.80624 3.64677 10.0179 3.59385 10.2296Z"
        fill="#B59F78"
      />
      <path
        d="M4.75992 10.6738C4.707 10.8959 4.47367 11.0334 4.25117 10.97C4.02825 10.9171 3.89034 10.6842 3.95409 10.4621C4.007 10.24 4.24034 10.1025 4.46325 10.1659C4.67534 10.2188 4.81325 10.4517 4.75992 10.6738Z"
        fill="#B59F78"
      />
      <path
        d="M5.99062 10.8326C5.92687 11.0651 5.69354 11.2026 5.46021 11.1496C5.22687 11.0863 5.08896 10.8538 5.14229 10.6209C5.20562 10.3884 5.43896 10.2505 5.67229 10.3034C5.90562 10.3671 6.05437 10.5996 5.99062 10.8326Z"
        fill="#B59F78"
      />
      <path
        d="M7.18875 10.7267C7.125 10.97 6.88125 11.1179 6.63708 11.0546C6.39333 10.9912 6.245 10.7479 6.30833 10.5046C6.37208 10.2612 6.61625 10.1129 6.86 10.1767C7.10375 10.24 7.2525 10.4833 7.18875 10.7267Z"
        fill="#B59F78"
      />
      <path
        d="M8.31288 10.367C8.24913 10.6208 7.98413 10.7795 7.72955 10.7162C7.47497 10.6524 7.3158 10.3883 7.37955 10.1341C7.4433 9.88035 7.7083 9.7216 7.96288 9.78494C8.22788 9.84869 8.37663 10.1129 8.31288 10.367Z"
        fill="#B59F78"
      />
      <path
        d="M9.33084 9.78503C9.26709 10.0496 8.99168 10.2084 8.72626 10.145C8.46126 10.0813 8.30209 9.80628 8.36584 9.5417C8.42959 9.27753 8.70543 9.11878 8.97043 9.18212C9.23543 9.24587 9.39459 9.51003 9.33084 9.78503Z"
        fill="#B59F78"
      />
      <path
        d="M10.1901 8.99169C10.1159 9.26669 9.84006 9.43628 9.56423 9.36211C9.2884 9.28794 9.11881 9.01294 9.19298 8.73794C9.26715 8.46294 9.54298 8.29378 9.81881 8.36753C10.0946 8.43128 10.2642 8.70628 10.1901 8.99169Z"
        fill="#B59F78"
      />
      <path
        d="M10.8687 8.00789C10.7945 8.29372 10.4974 8.4733 10.2112 8.39914C9.92495 8.32539 9.74453 8.02914 9.8187 7.7433C9.89287 7.45789 10.1899 7.27789 10.4762 7.35205C10.7733 7.42622 10.9429 7.72247 10.8687 8.00789Z"
        fill="#B59F78"
      />
      <path
        d="M11.3246 6.87627C11.2505 7.1721 10.943 7.3521 10.6459 7.27793C10.3492 7.20418 10.1688 6.8971 10.243 6.60085C10.3171 6.30502 10.6246 6.12502 10.9217 6.19918C11.2188 6.27293 11.3988 6.58002 11.3246 6.87627Z"
        fill="#B59F78"
      />
      <path
        d="M6.35075 1.24842C6.34033 1.30134 6.28741 1.333 6.23408 1.31175C6.18116 1.30134 6.1495 1.24842 6.17075 1.1955C6.18116 1.14259 6.23408 1.11092 6.28741 1.13217C6.3295 1.14259 6.36158 1.1955 6.35075 1.24842Z"
        fill="#B59F78"
      />
      <path
        d="M5.49217 1.13206C5.48134 1.18498 5.41758 1.22706 5.36467 1.20581C5.31175 1.1954 5.26925 1.13206 5.2905 1.07915C5.30134 1.02623 5.36467 0.983729 5.41759 1.00498C5.47092 1.0154 5.50259 1.07915 5.49217 1.13206Z"
        fill="#B59F78"
      />
      <path
        d="M4.65414 1.21658C4.63289 1.27991 4.56914 1.32241 4.50581 1.30116C4.44206 1.27991 4.39956 1.21658 4.42081 1.15283C4.44206 1.0895 4.50581 1.04741 4.56914 1.06825C4.63289 1.0895 4.67539 1.15283 4.65414 1.21658Z"
        fill="#B59F78"
      />
      <path
        d="M3.86977 1.49169C3.84852 1.56586 3.77393 1.60794 3.69976 1.58669C3.6256 1.56586 3.5831 1.49169 3.60435 1.41752C3.6256 1.34335 3.69976 1.30127 3.77393 1.32252C3.84852 1.34335 3.8906 1.41752 3.86977 1.49169Z"
        fill="#B59F78"
      />
      <path
        d="M3.16963 1.91449C3.14838 1.99949 3.06338 2.04158 2.98921 2.02033C2.90421 1.99949 2.86213 1.91449 2.88338 1.84074C2.90421 1.75616 2.98921 1.71366 3.06338 1.73491C3.13754 1.75616 3.18004 1.84074 3.16963 1.91449Z"
        fill="#B59F78"
      />
      <path
        d="M2.56488 2.49674C2.54363 2.58133 2.44821 2.64466 2.36321 2.61299C2.27863 2.59174 2.21488 2.49674 2.24654 2.41216C2.26779 2.32758 2.36321 2.26383 2.44821 2.29549C2.53321 2.31674 2.58613 2.41216 2.56488 2.49674Z"
        fill="#B59F78"
      />
      <path
        d="M2.10912 3.21579C2.08787 3.31121 1.98162 3.37454 1.8862 3.34288C1.79078 3.32163 1.72703 3.21579 1.75912 3.12079C1.78037 3.02538 1.8862 2.96204 1.98162 2.99371C2.06662 3.01496 2.12995 3.10996 2.10912 3.21579Z"
        fill="#B59F78"
      />
      <path
        d="M1.81211 4.04092C1.78045 4.14675 1.6742 4.2105 1.56795 4.17883C1.46211 4.14675 1.39836 4.04092 1.43045 3.9355C1.46211 3.82967 1.56795 3.76592 1.6742 3.798C1.76961 3.82967 1.83336 3.9355 1.81211 4.04092Z"
        fill="#B59F78"
      />
      <path
        d="M1.70593 4.91912C1.67426 5.03537 1.55759 5.0987 1.45176 5.06703C1.33509 5.03537 1.27134 4.91912 1.30301 4.81328C1.33509 4.69703 1.45176 4.63328 1.55759 4.66495C1.66384 4.6862 1.73801 4.80245 1.70593 4.91912Z"
        fill="#B59F78"
      />
      <path
        d="M1.80129 5.76539C1.76963 5.88164 1.64254 5.95581 1.52588 5.92414C1.40921 5.89206 1.33504 5.76539 1.36671 5.64914C1.39838 5.53248 1.52588 5.45873 1.64254 5.49039C1.75921 5.52206 1.83338 5.64914 1.80129 5.76539Z"
        fill="#B59F78"
      />
      <path
        d="M2.07714 6.56915C2.04548 6.69624 1.91798 6.78082 1.78048 6.74915C1.65298 6.71749 1.56798 6.5904 1.60006 6.4529C1.63173 6.32582 1.75923 6.24124 1.89673 6.2729C2.03464 6.30499 2.10923 6.44249 2.07714 6.56915Z"
        fill="#B59F78"
      />
      <path
        d="M2.52255 7.2887C2.49088 7.4262 2.35297 7.51078 2.21505 7.47912C2.07713 7.44745 1.99255 7.30953 2.02422 7.17203C2.05588 7.03453 2.1938 6.94995 2.33172 6.98161C2.48005 7.0137 2.55463 7.1512 2.52255 7.2887Z"
        fill="#B59F78"
      />
      <path
        d="M3.1162 7.90203C3.08453 8.05036 2.9362 8.13495 2.78745 8.10328C2.63912 8.0712 2.55453 7.92328 2.5862 7.77536C2.61787 7.62703 2.76662 7.54245 2.91495 7.57411C3.06328 7.61661 3.1587 7.76453 3.1162 7.90203Z"
        fill="#B59F78"
      />
      <path
        d="M3.83744 8.37833C3.79494 8.52624 3.64661 8.62166 3.48744 8.58958C3.33911 8.54749 3.24369 8.39916 3.27536 8.24083C3.31786 8.09249 3.46619 7.99749 3.62536 8.02916C3.78452 8.07124 3.87994 8.22999 3.83744 8.37833Z"
        fill="#B59F78"
      />
      <path
        d="M4.68582 8.69547C4.64373 8.85422 4.48457 8.94963 4.3254 8.91797C4.16623 8.87547 4.07082 8.71672 4.10248 8.55797C4.14498 8.39963 4.30415 8.30422 4.46332 8.33588C4.62248 8.36755 4.7179 8.53713 4.68582 8.69547Z"
        fill="#B59F78"
      />
      <path
        d="M5.57652 8.82248C5.53402 8.99165 5.36444 9.09748 5.19485 9.0554C5.02527 9.0129 4.91902 8.84373 4.96152 8.67457C5.00402 8.50498 5.1736 8.39915 5.34319 8.44165C5.51319 8.48415 5.61902 8.65332 5.57652 8.82248Z"
        fill="#B59F78"
      />
      <path
        d="M6.43572 8.73795C6.39322 8.91795 6.2128 9.02337 6.0328 8.98128C5.85238 8.93878 5.74613 8.7592 5.78863 8.5792C5.83113 8.39962 6.01155 8.29378 6.19155 8.33587C6.37197 8.38878 6.47822 8.56878 6.43572 8.73795Z"
        fill="#B59F78"
      />
      <path
        d="M7.25269 8.48408C7.21019 8.66367 7.01936 8.77992 6.82852 8.73783C6.64811 8.69533 6.53144 8.50492 6.57394 8.3145C6.61644 8.13492 6.80727 8.01867 6.99811 8.06075C7.18894 8.11367 7.29477 8.29367 7.25269 8.48408Z"
        fill="#B59F78"
      />
      <path
        d="M7.98412 8.05041C7.9312 8.24083 7.73995 8.35708 7.54912 8.31458C7.35828 8.26166 7.24162 8.07124 7.28412 7.88083C7.33703 7.69041 7.52787 7.57416 7.71912 7.61666C7.92037 7.66957 8.03703 7.85999 7.98412 8.05041Z"
        fill="#B59F78"
      />
      <path
        d="M8.6095 7.4792C8.55659 7.68004 8.35534 7.79629 8.15367 7.7542C7.952 7.70129 7.83534 7.50004 7.87784 7.2992C7.93117 7.09837 8.13242 6.9817 8.33409 7.0242C8.53534 7.07712 8.66284 7.27795 8.6095 7.4792Z"
        fill="#B59F78"
      />
      <path
        d="M9.09748 6.78082C9.04456 6.99249 8.83248 7.11915 8.6204 7.06665C8.40831 7.01374 8.28081 6.80207 8.33415 6.5904C8.38706 6.37873 8.59915 6.25207 8.81123 6.30498C9.02331 6.3579 9.15081 6.56915 9.09748 6.78082Z"
        fill="#B59F78"
      />
      <path
        d="M9.42632 5.95592C9.3734 6.16758 9.1509 6.30508 8.9384 6.25217C8.72632 6.19925 8.58882 5.97717 8.64173 5.7655C8.69465 5.55383 8.91757 5.41633 9.12965 5.46925C9.35215 5.52217 9.47965 5.74425 9.42632 5.95592Z"
        fill="#B59F78"
      />
      <mask
        id="mask2_3_210"
        maskUnits="userSpaceOnUse"
        x="10"
        y="11"
        width="1"
        height="1"
      >
        <path
          d="M10.0801 11.1613H10.4001V11.52H10.0801V11.1613Z"
          fill="currentColor"
        />
      </mask>
      <g mask="url(#mask2_3_210)">
        <path
          d="M10.0945 11.3825C10.0945 11.3083 10.1578 11.2554 10.2324 11.2554C10.3066 11.2554 10.3595 11.3191 10.3595 11.3929C10.3595 11.467 10.2957 11.52 10.2216 11.52C10.1474 11.5095 10.0945 11.4458 10.0945 11.3825Z"
          fill="#B59F78"
        />
      </g>
      <path
        d="M11.293 11.2767C11.293 11.1921 11.3671 11.1288 11.4521 11.1288C11.5367 11.1288 11.6005 11.2025 11.6005 11.2875C11.6005 11.3721 11.5263 11.4355 11.4413 11.4355C11.3563 11.4355 11.293 11.3613 11.293 11.2767Z"
        fill="#B59F78"
      />
      <path
        d="M12.396 10.9171C12.396 10.8216 12.4806 10.7479 12.576 10.7583C12.6718 10.7583 12.746 10.8429 12.7352 10.9383C12.7352 11.0333 12.6506 11.1075 12.5552 11.0971C12.4702 11.0971 12.396 11.0121 12.396 10.9171Z"
        fill="#B59F78"
      />
      <path
        d="M13.3821 10.3355C13.3821 10.2297 13.4775 10.1451 13.5833 10.1555C13.6896 10.1659 13.7746 10.2505 13.7637 10.3564C13.7637 10.4622 13.6683 10.5468 13.5621 10.5364C13.4667 10.5259 13.3821 10.4409 13.3821 10.3355Z"
        fill="#B59F78"
      />
      <path
        d="M14.2092 9.5417C14.2092 9.42545 14.3155 9.33045 14.4321 9.34087C14.5484 9.34087 14.6442 9.4467 14.6334 9.56295C14.6334 9.67962 14.5276 9.77462 14.4109 9.7642C14.2942 9.75337 14.2092 9.65837 14.2092 9.5417Z"
        fill="#B59F78"
      />
      <path
        d="M14.8455 8.57914C14.8455 8.45206 14.9621 8.35706 15.0896 8.35706C15.2167 8.35706 15.3121 8.46289 15.3121 8.60039C15.3121 8.72747 15.2059 8.82247 15.0684 8.82247C14.9409 8.81206 14.8455 8.70622 14.8455 8.57914Z"
        fill="#B59F78"
      />
      <path
        d="M15.2593 7.47917C15.2593 7.34167 15.3759 7.23584 15.5243 7.23584C15.6622 7.23584 15.768 7.35209 15.768 7.50001C15.768 7.63792 15.6514 7.74334 15.503 7.74334C15.3651 7.74334 15.2593 7.62709 15.2593 7.47917Z"
        fill="#B59F78"
      />
      <mask
        id="mask3_3_210"
        maskUnits="userSpaceOnUse"
        x="15"
        y="5"
        width="1"
        height="2"
      >
        <path
          d="M15.4133 5.93457H16V6.57457H15.4133V5.93457Z"
          fill="currentColor"
        />
      </mask>
      <g mask="url(#mask3_3_210)">
        <path
          d="M15.4286 6.27296C15.4286 6.12504 15.5557 6.00879 15.7149 6.00879C15.8632 6.00879 15.9799 6.13546 15.9799 6.29421C15.9799 6.44254 15.8528 6.55879 15.6936 6.55879C15.5345 6.54837 15.4182 6.43171 15.4286 6.27296Z"
          fill="#B59F78"
        />
      </g>
      <path
        d="M15.3018 5.06703C15.3122 4.90828 15.4393 4.78162 15.6093 4.78162C15.768 4.79203 15.8955 4.91912 15.8955 5.08828C15.8847 5.24703 15.7576 5.3737 15.588 5.3737C15.4288 5.36328 15.3018 5.22578 15.3018 5.06703Z"
        fill="#B59F78"
      />
      <path
        d="M14.9305 3.9355C14.9409 3.76592 15.0789 3.62842 15.2593 3.62842C15.4289 3.63925 15.5668 3.77675 15.5668 3.95633C15.5559 4.12592 15.4184 4.26342 15.238 4.26342C15.0576 4.25259 14.9197 4.10467 14.9305 3.9355Z"
        fill="#B59F78"
      />
      <path
        d="M14.3155 2.93045C14.3259 2.75045 14.4742 2.60253 14.6651 2.61295C14.8455 2.62336 14.9938 2.7717 14.9834 2.96211C14.973 3.1417 14.8242 3.29003 14.6334 3.27961C14.453 3.26878 14.3047 3.12086 14.3155 2.93045Z"
        fill="#B59F78"
      />
      <path
        d="M13.4988 2.08423C13.5092 1.89381 13.6684 1.73506 13.87 1.74548C14.0713 1.75631 14.2196 1.91465 14.2092 2.1159C14.1988 2.30631 14.0396 2.46506 13.8379 2.45423C13.6471 2.44381 13.4988 2.28506 13.4988 2.08423Z"
        fill="#B59F78"
      />
      <path
        d="M12.5229 1.42836C12.5338 1.21669 12.7034 1.05794 12.9154 1.06836C13.1275 1.07919 13.2867 1.24836 13.2759 1.46002C13.2654 1.67127 13.0959 1.83002 12.8838 1.81961C12.6717 1.80919 12.5125 1.63961 12.5229 1.42836Z"
        fill="#B59F78"
      />
      <path
        d="M11.3989 0.994607C11.4097 0.772107 11.5897 0.60294 11.8126 0.613774C12.0351 0.62419 12.2051 0.804191 12.1943 1.02627C12.1839 1.24836 12.0035 1.41752 11.781 1.40711C11.5689 1.39627 11.3885 1.21669 11.3989 0.994607Z"
        fill="#B59F78"
      />
      <path
        d="M10.1687 0.814624C10.1791 0.581707 10.3699 0.402124 10.6033 0.412541C10.8366 0.423374 11.017 0.613791 11.0066 0.846291C10.9958 1.07921 10.8049 1.25879 10.5716 1.24837C10.3383 1.23796 10.1578 1.04754 10.1687 0.814624Z"
        fill="#B59F78"
      />
      <path
        d="M8.92798 0.909531C8.9384 0.666614 9.14006 0.476197 9.38381 0.486614C9.62798 0.497031 9.81881 0.698281 9.8084 0.941614C9.79756 1.18495 9.5959 1.37536 9.35215 1.36453C9.1084 1.35411 8.92798 1.15286 8.92798 0.909531Z"
        fill="#B59F78"
      />
      <path
        d="M7.78261 1.26953C7.79345 1.01537 8.00553 0.824951 8.26011 0.824951C8.51428 0.835785 8.70553 1.04745 8.70553 1.3012C8.6947 1.55495 8.48261 1.74537 8.22803 1.74537C7.97345 1.73495 7.7722 1.52329 7.78261 1.26953Z"
        fill="#B59F78"
      />
      <path
        d="M6.76458 1.86166C6.77499 1.59749 6.99791 1.39624 7.26291 1.39624C7.52791 1.40707 7.72958 1.62916 7.72958 1.89374C7.71916 2.15791 7.49624 2.35916 7.23124 2.35916C6.95541 2.33791 6.75374 2.12624 6.76458 1.86166Z"
        fill="#B59F78"
      />
      <path
        d="M5.89493 2.64457C5.90535 2.36957 6.13868 2.1579 6.41451 2.16873C6.69035 2.17915 6.90243 2.41207 6.8916 2.68707C6.88118 2.96207 6.64785 3.17373 6.37201 3.1629C6.09618 3.15248 5.8841 2.91957 5.89493 2.64457Z"
        fill="#B59F78"
      />
      <path
        d="M5.2162 3.60747C5.22662 3.32164 5.47078 3.09955 5.75703 3.10997C6.04328 3.1208 6.2662 3.36414 6.25537 3.64955C6.24495 3.93539 6.00078 4.15747 5.71453 4.14664C5.42828 4.13622 5.20537 3.89289 5.2162 3.60747Z"
        fill="#B59F78"
      />
      <path
        d="M4.7601 4.70751C4.77093 4.41126 5.02552 4.17876 5.32219 4.18918C5.61927 4.1996 5.8526 4.45376 5.84219 4.7496C5.83135 5.04585 5.57677 5.27876 5.2801 5.26835C4.98302 5.2471 4.74968 5.00376 4.7601 4.70751Z"
        fill="#B59F78"
      />
      <path
        d="M4.5587 5.90282C4.56911 5.59615 4.8237 5.35282 5.14203 5.36324C5.44953 5.37365 5.69328 5.62782 5.68286 5.9449C5.67203 6.25199 5.41745 6.49532 5.09953 6.48449C4.79203 6.47407 4.54786 6.2199 4.5587 5.90282Z"
        fill="#B59F78"
      />
      <path
        d="M10.6142 10.3563C10.6142 10.3034 10.6567 10.2613 10.7097 10.2717C10.7626 10.2717 10.8051 10.3142 10.7947 10.3672C10.7947 10.4201 10.7522 10.4622 10.6988 10.4517C10.6459 10.4517 10.6034 10.4092 10.6142 10.3563Z"
        fill="#B59F78"
      />
      <path
        d="M11.4729 10.293C11.4729 10.2296 11.5262 10.1871 11.5896 10.1871C11.6533 10.1871 11.6958 10.2401 11.6958 10.3034C11.6958 10.3671 11.6429 10.4092 11.5896 10.4092C11.5154 10.3988 11.4729 10.3459 11.4729 10.293Z"
        fill="#B59F78"
      />
      <path
        d="M12.2792 10.0284C12.2792 9.96503 12.343 9.91211 12.4063 9.91211C12.4701 9.91211 12.523 9.97544 12.523 10.0392C12.523 10.1025 12.4592 10.1554 12.3959 10.1554C12.3217 10.1554 12.2684 10.1025 12.2792 10.0284Z"
        fill="#B59F78"
      />
      <path
        d="M12.9896 9.6054C12.9896 9.53123 13.0534 9.4679 13.1276 9.4679C13.2017 9.4679 13.2655 9.53123 13.2655 9.6054C13.2655 9.67915 13.2017 9.7429 13.1276 9.7429C13.0426 9.7429 12.9792 9.67915 12.9896 9.6054Z"
        fill="#B59F78"
      />
      <path
        d="M13.5833 9.0342C13.5833 8.94961 13.6578 8.88586 13.7424 8.88586C13.8274 8.88586 13.8908 8.96003 13.8908 9.04461C13.8908 9.1292 13.8166 9.19295 13.732 9.19295C13.647 9.18211 13.5833 9.11878 13.5833 9.0342Z"
        fill="#B59F78"
      />
      <path
        d="M14.0396 8.33588C14.0396 8.24088 14.1241 8.16671 14.2091 8.17713C14.3046 8.17713 14.3787 8.26171 14.3683 8.34671C14.3683 8.44171 14.2833 8.51588 14.1987 8.50504C14.1137 8.50504 14.0396 8.43129 14.0396 8.33588Z"
        fill="#B59F78"
      />
      <path
        d="M14.3471 7.54255C14.3471 7.44755 14.4321 7.36255 14.538 7.36255C14.6334 7.36255 14.7184 7.44755 14.7184 7.55297C14.7184 7.64838 14.6334 7.73297 14.5275 7.73297C14.4213 7.73297 14.3363 7.64838 14.3471 7.54255Z"
        fill="#B59F78"
      />
      <path
        d="M14.4638 6.67504C14.4638 6.5692 14.5592 6.48462 14.6651 6.48462C14.7713 6.48462 14.8563 6.58004 14.8563 6.68587C14.8563 6.79129 14.7609 6.87629 14.6547 6.87629C14.538 6.87629 14.453 6.78087 14.4638 6.67504Z"
        fill="#B59F78"
      />
      <path
        d="M14.379 5.79713C14.379 5.68088 14.4852 5.58547 14.6019 5.5963C14.7185 5.5963 14.814 5.70172 14.8031 5.81838C14.8031 5.93463 14.6973 6.02963 14.5806 6.01922C14.464 6.0088 14.3685 5.91338 14.379 5.79713Z"
        fill="#B59F78"
      />
      <path
        d="M14.1034 4.98246C14.1034 4.85538 14.2092 4.76038 14.3363 4.76038C14.4638 4.76038 14.5592 4.86621 14.5592 4.99288C14.5592 5.11996 14.453 5.21538 14.3259 5.21538C14.188 5.21538 14.0925 5.10954 14.1034 4.98246Z"
        fill="#B59F78"
      />
      <path
        d="M13.658 4.26331C13.658 4.12581 13.7746 4.0304 13.9121 4.0304C14.05 4.0304 14.1455 4.14665 14.1455 4.28415C14.1455 4.42165 14.0288 4.51706 13.8909 4.51706C13.7534 4.50665 13.658 4.38998 13.658 4.26331Z"
        fill="#B59F78"
      />
      <path
        d="M13.0744 3.6495C13.0744 3.512 13.2015 3.39575 13.3394 3.40617C13.4773 3.40617 13.594 3.53325 13.5832 3.67075C13.5832 3.80825 13.4561 3.9245 13.3182 3.91408C13.1803 3.90325 13.0636 3.787 13.0744 3.6495Z"
        fill="#B59F78"
      />
      <path
        d="M12.3637 3.17376C12.3637 3.02543 12.4912 2.90918 12.6395 2.90918C12.7879 2.90918 12.9045 3.03626 12.9045 3.18418C12.9045 3.3321 12.7774 3.44876 12.6291 3.44876C12.4699 3.44876 12.3533 3.32168 12.3637 3.17376Z"
        fill="#B59F78"
      />
      <path
        d="M11.5476 2.85633C11.558 2.69758 11.6851 2.5705 11.8443 2.58133C12.0034 2.59175 12.1305 2.71883 12.1201 2.87758C12.1201 3.03633 11.9822 3.163 11.823 3.15258C11.6747 3.14175 11.5476 3.01508 11.5476 2.85633Z"
        fill="#B59F78"
      />
      <path
        d="M10.6671 2.72905C10.6779 2.55989 10.8154 2.4328 10.9746 2.44364C11.1442 2.45405 11.2717 2.59155 11.2609 2.7503C11.2504 2.91947 11.1125 3.04655 10.9534 3.03614C10.7838 3.0253 10.6567 2.8878 10.6671 2.72905Z"
        fill="#B59F78"
      />
      <path
        d="M9.76587 2.79292C9.77629 2.62334 9.9142 2.48584 10.0946 2.48584C10.2642 2.49667 10.4021 2.63417 10.4021 2.81376C10.3913 2.98334 10.2538 3.12084 10.0734 3.12084C9.90379 3.11001 9.76587 2.97251 9.76587 2.79292Z"
        fill="#B59F78"
      />
      <path
        d="M8.93826 3.05714C8.94909 2.87756 9.09743 2.72923 9.27784 2.74006C9.45826 2.75048 9.6066 2.89881 9.59576 3.07839C9.58535 3.25839 9.43701 3.40631 9.25659 3.39589C9.07618 3.38506 8.92784 3.23714 8.93826 3.05714Z"
        fill="#B59F78"
      />
      <path
        d="M8.19629 3.48045C8.20671 3.29004 8.36587 3.1417 8.55671 3.15254C8.74754 3.16295 8.89629 3.3217 8.88546 3.51212C8.87504 3.70254 8.71587 3.85045 8.52504 3.84004C8.34462 3.82962 8.19629 3.67087 8.19629 3.48045Z"
        fill="#B59F78"
      />
      <path
        d="M7.57031 4.05168C7.58114 3.85043 7.73989 3.70251 7.94156 3.70251C8.14322 3.71293 8.29156 3.87168 8.29156 4.07293C8.28073 4.27377 8.12197 4.42168 7.92031 4.42168C7.71906 4.41127 7.55989 4.25252 7.57031 4.05168Z"
        fill="#B59F78"
      />
      <path
        d="M7.08251 4.73922C7.09335 4.52755 7.26293 4.36922 7.47501 4.37964C7.6871 4.39005 7.84627 4.55964 7.83543 4.77089C7.82502 4.98255 7.65543 5.1413 7.44335 5.13047C7.23126 5.12005 7.0721 4.95089 7.08251 4.73922Z"
        fill="#B59F78"
      />
      <path
        d="M6.75363 5.53244C6.76446 5.32078 6.94488 5.15161 7.15696 5.15161C7.36905 5.16244 7.53863 5.34203 7.53863 5.55369C7.5278 5.76536 7.3478 5.93453 7.13571 5.93453C6.9128 5.93453 6.74321 5.75453 6.75363 5.53244Z"
        fill="#B59F78"
      />
      <path
        d="M6.60541 6.41036C6.61624 6.18827 6.79624 6.00869 7.01916 6.01911C7.24166 6.02952 7.42208 6.20953 7.41124 6.43161C7.40083 6.65369 7.22041 6.83369 6.99791 6.82328C6.77499 6.81244 6.59499 6.63286 6.60541 6.41036Z"
        fill="#B59F78"
      />
    </svg>
  );
  export const features1 = (
    <svg viewBox="0 0 32 32" fill="none">
      <path
        d="M9.5062 2.38748C10.125 2.94373 10.175 3.88748 9.6187 4.50623L5.1187 9.50623C4.8437 9.81248 4.4562 9.99373 4.0437 9.99998C3.6312 10.0062 3.23745 9.84998 2.9437 9.56248L0.437451 7.06248C-0.143799 6.47498 -0.143799 5.52498 0.437451 4.93748C1.0187 4.34998 1.97495 4.34998 2.5562 4.93748L3.93745 6.31873L7.3812 2.49373C7.93745 1.87498 8.8812 1.82498 9.49995 2.38123L9.5062 2.38748ZM9.5062 12.3875C10.125 12.9437 10.175 13.8875 9.6187 14.5062L5.1187 19.5062C4.8437 19.8125 4.4562 19.9937 4.0437 20C3.6312 20.0062 3.23745 19.85 2.9437 19.5625L0.437451 17.0625C-0.150049 16.475 -0.150049 15.525 0.437451 14.9437C1.02495 14.3625 1.97495 14.3562 2.5562 14.9437L3.93745 16.325L7.3812 12.5C7.93745 11.8812 8.8812 11.8312 9.49995 12.3875H9.5062ZM14 5.99998C14 4.89373 14.8937 3.99998 16 3.99998H30C31.1062 3.99998 32 4.89373 32 5.99998C32 7.10623 31.1062 7.99998 30 7.99998H16C14.8937 7.99998 14 7.10623 14 5.99998ZM14 16C14 14.8937 14.8937 14 16 14H30C31.1062 14 32 14.8937 32 16C32 17.1062 31.1062 18 30 18H16C14.8937 18 14 17.1062 14 16ZM9.99995 26C9.99995 24.8937 10.8937 24 12 24H30C31.1062 24 32 24.8937 32 26C32 27.1062 31.1062 28 30 28H12C10.8937 28 9.99995 27.1062 9.99995 26ZM2.99995 23C3.7956 23 4.55866 23.3161 5.12127 23.8787C5.68388 24.4413 5.99995 25.2043 5.99995 26C5.99995 26.7956 5.68388 27.5587 5.12127 28.1213C4.55866 28.6839 3.7956 29 2.99995 29C2.2043 29 1.44124 28.6839 0.878631 28.1213C0.316022 27.5587 -4.8846e-05 26.7956 -4.8846e-05 26C-4.8846e-05 25.2043 0.316022 24.4413 0.878631 23.8787C1.44124 23.3161 2.2043 23 2.99995 23Z"
        fill="currentColor"
      />
    </svg>
  );
  export const features2 = (
    <svg viewBox="0 0 24 32" fill="none">
      <path
        d="M12 0C9.3875 0 7.1625 1.66875 6.34375 4H4C1.79375 4 0 5.79375 0 8V28C0 30.2062 1.79375 32 4 32H20C22.2062 32 24 30.2062 24 28V8C24 5.79375 22.2062 4 20 4H17.6562C16.8375 1.66875 14.6125 0 12 0ZM12 4C12.5304 4 13.0391 4.21071 13.4142 4.58579C13.7893 4.96086 14 5.46957 14 6C14 6.53043 13.7893 7.03914 13.4142 7.41421C13.0391 7.78929 12.5304 8 12 8C11.4696 8 10.9609 7.78929 10.5858 7.41421C10.2107 7.03914 10 6.53043 10 6C10 5.46957 10.2107 4.96086 10.5858 4.58579C10.9609 4.21071 11.4696 4 12 4ZM6.6125 14.3313C7.10625 12.9375 8.43125 12 9.9125 12H13.5562C15.7375 12 17.5 13.7688 17.5 15.9438C17.5 17.3563 16.7437 18.6625 15.5188 19.3687L13.5 20.525C13.4875 21.3375 12.8188 22 12 22C11.1687 22 10.5 21.3312 10.5 20.5V19.6562C10.5 19.1187 10.7875 18.625 11.2563 18.3563L14.025 16.7687C14.3187 16.6 14.5 16.2875 14.5 15.95C14.5 15.425 14.075 15.0063 13.5562 15.0063H9.9125C9.7 15.0063 9.5125 15.1375 9.44375 15.3375L9.41875 15.4125C9.14375 16.1938 8.28125 16.6 7.50625 16.325C6.73125 16.05 6.31875 15.1875 6.59375 14.4125L6.61875 14.3375L6.6125 14.3313ZM10 26C10 25.4696 10.2107 24.9609 10.5858 24.5858C10.9609 24.2107 11.4696 24 12 24C12.5304 24 13.0391 24.2107 13.4142 24.5858C13.7893 24.9609 14 25.4696 14 26C14 26.5304 13.7893 27.0391 13.4142 27.4142C13.0391 27.7893 12.5304 28 12 28C11.4696 28 10.9609 27.7893 10.5858 27.4142C10.2107 27.0391 10 26.5304 10 26Z"
        fill="currentColor"
      />
    </svg>
  );
  export const features3 = (
    <svg viewBox="0 0 32 37" fill="none">
      <path
        d="M6.85714 9.14286C6.85714 11.5677 7.82041 13.8932 9.53502 15.6078C11.2496 17.3225 13.5752 18.2857 16 18.2857C18.4248 18.2857 20.7504 17.3225 22.465 15.6078C24.1796 13.8932 25.1429 11.5677 25.1429 9.14286C25.1429 6.71802 24.1796 4.3925 22.465 2.67788C20.7504 0.963263 18.4248 0 16 0C13.5752 0 11.2496 0.963263 9.53502 2.67788C7.82041 4.3925 6.85714 6.71802 6.85714 9.14286ZM13.6071 23.4429L14.9357 25.6571L12.5571 34.5071L9.98571 24.0143C9.84286 23.4357 9.28572 23.0571 8.70714 23.2071C3.70714 24.4571 0 28.9857 0 34.3786C0 35.5929 0.985714 36.5714 2.19286 36.5714H11.6C11.6 36.5714 11.6 36.5714 11.6071 36.5714H12H20H20.3929C20.3929 36.5714 20.3929 36.5714 20.4 36.5714H29.8071C31.0214 36.5714 32 35.5857 32 34.3786C32 28.9857 28.2929 24.4571 23.2929 23.2071C22.7143 23.0643 22.1571 23.4429 22.0143 24.0143L19.4429 34.5071L17.0643 25.6571L18.3929 23.4429C18.85 22.6786 18.3 21.7143 17.4143 21.7143H16H14.5929C13.7071 21.7143 13.1571 22.6857 13.6143 23.4429H13.6071Z"
        fill="currentColor"
      />
    </svg>
  );
  
  export const features4 = (
    <svg viewBox="0 0 32 37" fill="none">
      <path
        d="M3.42854 9.14288C2.16425 9.14288 1.14282 10.1643 1.14282 11.4286C1.14282 12.6929 2.16425 13.7143 3.42854 13.7143H28.5714C29.8357 13.7143 30.8571 12.6929 30.8571 11.4286C30.8571 10.1643 29.8357 9.14288 28.5714 9.14288H3.42854ZM3.42854 22.8572C2.16425 22.8572 1.14282 23.8786 1.14282 25.1429C1.14282 26.4072 2.16425 27.4286 3.42854 27.4286H28.5714C29.8357 27.4286 30.8571 26.4072 30.8571 25.1429C30.8571 23.8786 29.8357 22.8572 28.5714 22.8572H3.42854Z"
        fill="currentColor"
      />
    </svg>
  );
  export const benefits1 = (
    <svg viewBox="0 0 24 33" fill="none">
      <path
        d="M9.6 2.36875L10.6 1.0375C10.85 0.7 11.25 0.5 11.6687 0.5C12.4 0.5 13 1.1 13 1.83125V3.21875C13 4.0375 13.3375 4.825 13.9312 5.3875L19.225 10.4375C22.275 13.35 24 17.3875 24 21.6063C24 27.625 19.125 32.5 13.1062 32.5H12C5.375 32.5 0 27.125 0 20.5V20.2625C0 17.2125 1.2125 14.2875 3.36875 12.1313L3.5875 11.9125C3.85 11.65 4.2125 11.5 4.5875 11.5C5.36875 11.5 6 12.1313 6 12.9125V18.5C6 20.7062 7.79375 22.5 10 22.5C12.2062 22.5 14 20.7062 14 18.5V18.2563C14 17.1313 13.55 16.05 12.7562 15.2563L10.3437 12.8438C8.84375 11.3438 8 9.3 8 7.175C8 5.44375 8.5625 3.75 9.6 2.36875Z"
        fill="#2A3663"
      />
    </svg>
  );
  export const benefits2 = (
    <svg viewBox="0 0 40 33" fill="none">
      <path
        d="M14 16.5C16.1217 16.5 18.1566 15.6571 19.6569 14.1569C21.1571 12.6566 22 10.6217 22 8.5C22 6.37827 21.1571 4.34344 19.6569 2.84315C18.1566 1.34285 16.1217 0.5 14 0.5C11.8783 0.5 9.84344 1.34285 8.34315 2.84315C6.84285 4.34344 6 6.37827 6 8.5C6 10.6217 6.84285 12.6566 8.34315 14.1569C9.84344 15.6571 11.8783 16.5 14 16.5ZM11.1438 19.5C4.9875 19.5 0 24.4875 0 30.6437C0 31.6687 0.83125 32.5 1.85625 32.5H26.1437C26.2562 32.5 26.3625 32.4875 26.475 32.4688C21.7062 29.025 20.2375 23.6562 20.0312 19.9562C19.025 19.6562 17.9625 19.5 16.8625 19.5H11.15H11.1438ZM30.4438 14.6062L22.9438 17.6063C22.375 17.8375 22 18.3875 22 19C22 22.9562 23.6187 29.55 30.425 32.3875C30.7937 32.5438 31.2125 32.5438 31.5812 32.3875C38.3812 29.55 40 22.9562 40 19C40 18.3875 39.625 17.8375 39.0563 17.6063L31.5562 14.6062C31.2 14.4625 30.8 14.4625 30.4438 14.6062ZM36.9625 20C36.7188 23.1688 35.2625 27.2938 31 29.3563V17.6187L36.9625 20Z"
        fill="#2A3663"
      />
    </svg>
  );
  export const benefits3 = (
    <svg viewBox="0 0 32 33" fill="none">
      <path
        d="M28 10.5H20V8.5H28V10.5ZM3 4.5C1.34375 4.5 0 5.84375 0 7.5V11.5C0 13.1562 1.34375 14.5 3 14.5H29C30.6562 14.5 32 13.1562 32 11.5V7.5C32 5.84375 30.6562 4.5 29 4.5H3ZM28 22.5V24.5H12V22.5H28ZM3 18.5C1.34375 18.5 0 19.8438 0 21.5V25.5C0 27.1562 1.34375 28.5 3 28.5H29C30.6562 28.5 32 27.1562 32 25.5V21.5C32 19.8438 30.6562 18.5 29 18.5H3Z"
        fill="#2A3663"
      />
    </svg>
  );
  export const benefits4 = (
    <svg viewBox="0 0 32 33" fill="none">
      <path
        d="M29 16.5C29 19.9478 27.6304 23.2544 25.1924 25.6924C22.7544 28.1304 19.4478 29.5 16 29.5C12.5522 29.5 9.24558 28.1304 6.80761 25.6924C4.36964 23.2544 3 19.9478 3 16.5C3 13.0522 4.36964 9.74558 6.80761 7.30761C9.24558 4.86964 12.5522 3.5 16 3.5C19.4478 3.5 22.7544 4.86964 25.1924 7.30761C27.6304 9.74558 29 13.0522 29 16.5ZM0 16.5C0 20.7435 1.68571 24.8131 4.68629 27.8137C7.68687 30.8143 11.7565 32.5 16 32.5C20.2435 32.5 24.3131 30.8143 27.3137 27.8137C30.3143 24.8131 32 20.7435 32 16.5C32 12.2565 30.3143 8.18687 27.3137 5.18629C24.3131 2.18571 20.2435 0.5 16 0.5C11.7565 0.5 7.68687 2.18571 4.68629 5.18629C1.68571 8.18687 0 12.2565 0 16.5ZM14.5 8V16.5C14.5 17 14.75 17.4688 15.1687 17.75L21.1688 21.75C21.8563 22.2125 22.7875 22.025 23.25 21.3312C23.7125 20.6375 23.525 19.7125 22.8312 19.25L17.5 15.7V8C17.5 7.16875 16.8312 6.5 16 6.5C15.1687 6.5 14.5 7.16875 14.5 8Z"
        fill="#2A3663"
      />
    </svg>
  );
  export const chevronBottom = (
    <svg viewBox="0 0 24 24" fill="none">
      <path
        d="M6 9.00005C6 9.00005 10.4189 15 12 15C13.5812 15 18 9 18 9"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
  export const instagram = (
    <svg viewBox="0 0 20 20" fill="none">
      <path
        d="M17.9166 3.75016V16.2502C17.9166 17.1707 17.1704 17.9168 16.2499 17.9168H3.74992C2.82944 17.9168 2.08325 17.1707 2.08325 16.2502V3.75016C2.08325 2.82969 2.82944 2.0835 3.74992 2.0835H16.2499C17.1704 2.0835 17.9166 2.82969 17.9166 3.75016Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.75 10C13.75 12.0711 12.0711 13.75 10 13.75C7.92893 13.75 6.25 12.0711 6.25 10C6.25 7.92893 7.92893 6.25 10 6.25C12.0711 6.25 13.75 7.92893 13.75 10Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M14.5898 5.4165H14.5823"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
  export const twitter = (
    <svg viewBox="0 0 20 20" fill="none">
      <path
        d="M1.96408 2.31761C2.10299 2.04594 2.38238 1.875 2.6875 1.875H6.75C7.0109 1.875 7.25593 2.00028 7.40868 2.21179L11.2795 7.57142L16.738 2.11298C17.0553 1.79568 17.5698 1.79568 17.887 2.11298C18.2043 2.43028 18.2043 2.94473 17.887 3.26202L12.2433 8.90583L17.9712 16.8367C18.1498 17.0842 18.1748 17.4108 18.0359 17.6824C17.897 17.9541 17.6176 18.125 17.3125 18.125H13.25C12.9891 18.125 12.7441 17.9998 12.5913 17.7882L8.7205 12.4286L3.26203 17.887C2.94473 18.2043 2.43028 18.2043 2.11298 17.887C1.79568 17.5697 1.79568 17.0552 2.11298 16.738L7.75676 11.0942L2.02883 3.16321C1.85018 2.91586 1.82518 2.58928 1.96408 2.31761Z"
        fill="currentColor"
      />
    </svg>
  );
  export const linkedin = (
    <svg viewBox="0 0 20 20" fill="none">
      <path
        d="M4.16659 7.5H3.74992C2.96424 7.5 2.57141 7.5 2.32733 7.74407C2.08325 7.98816 2.08325 8.381 2.08325 9.16667V16.25C2.08325 17.0357 2.08325 17.4285 2.32733 17.6726C2.57141 17.9167 2.96424 17.9167 3.74992 17.9167H4.16659C4.95226 17.9167 5.34509 17.9167 5.58918 17.6726C5.83325 17.4285 5.83325 17.0357 5.83325 16.25V9.16667C5.83325 8.381 5.83325 7.98816 5.58918 7.74407C5.34509 7.5 4.95226 7.5 4.16659 7.5Z"
        fill="currentColor"
      />
      <path
        d="M5.83325 3.625C5.83325 4.66053 4.99379 5.5 3.95825 5.5C2.92272 5.5 2.08325 4.66053 2.08325 3.625C2.08325 2.58947 2.92272 1.75 3.95825 1.75C4.99379 1.75 5.83325 2.58947 5.83325 3.625Z"
        fill="currentColor"
      />
      <path
        d="M10.1883 7.5H9.49992C8.71425 7.5 8.32141 7.5 8.07733 7.74407C7.83325 7.98816 7.83325 8.381 7.83325 9.16667V16.25C7.83325 17.0357 7.83325 17.4285 8.07733 17.6726C8.32141 17.9167 8.71425 17.9167 9.49992 17.9167H9.91659C10.7023 17.9167 11.0951 17.9167 11.3392 17.6726C11.5833 17.4285 11.5833 17.0357 11.5833 16.25L11.5833 13.3334C11.5833 11.9527 12.0233 10.8334 13.3232 10.8334C13.973 10.8334 14.4999 11.3931 14.4999 12.0834V15.8334C14.4999 16.6191 14.4999 17.0119 14.744 17.256C14.988 17.5001 15.3809 17.5001 16.1666 17.5001H16.5822C17.3677 17.5001 17.7604 17.5001 18.0045 17.2561C18.2486 17.0121 18.2487 16.6193 18.2488 15.8338L18.25 11.2502C18.25 9.17917 16.2803 7.5002 14.3306 7.5002C13.2207 7.5002 12.2305 8.04424 11.5833 8.895C11.5833 8.36992 11.5833 8.10744 11.4693 7.9125C11.397 7.78905 11.2942 7.68628 11.1708 7.61406C10.9758 7.5 10.7133 7.5 10.1883 7.5Z"
        fill="currentColor"
      />
    </svg>
  );